export default "__VITE_ASSET__DFR_LYdf__"